"use client";

import dynamic from "next/dynamic";
import type { HeroAgentClientProps } from "./HeroAgentClient";

const HeroAgentClient = dynamic(() => import("./HeroAgentClient").then(mod => mod.default));

export default function HeroAgentClientWrapper(props: HeroAgentClientProps) {
  return <HeroAgentClient {...props} />;
}
